module.exports = __webpack_public_path__ + "static/media/ee_mob_s.f7a28206.png";